
<div class="w-full flex flex-row justify-center bg-themeComponentBg-light font-rubik cover-cards-outer-container">
  <div class="w-full max-w-1440 cover-cards-container mx-5 flex flex-col lg:flex-row  gap-1">
    <Card v-for="data in cardsData" :key="data.title" :data="data" class="w-full" />
  </div>
</div>
